import React,{useState} from "react";
import "./intro.scss";

export default function Intro(){

   const[termsAccepted,setTermsAccepted]=useState(false);
   const [name, setName] = useState('');
  const [number, setNumber] = useState('');

  const [email, setEmail] = useState('');
  const [nameError, setNameError] = useState(null);

  const [numberError, setNumberError] = useState(null);
  const [emailError, setEmailError] = useState(null);

  const validateName = () => {
    const pattern = /^[a-zA-Z]+$/;
    if (!name) {
      setNameError('Name is required.');
      return false;
    } else if (!pattern.test(name)) {
      setNameError('Name should only contain letters.');
      return false;
    }
    setNameError(null);
    return true;
  };

  const validateNumber = () => {
    if (!/^\d+$/.test(number)) {
      setNumberError('Number must be a positive integer.');
      return false;
    }

    if(number.length<10)
    {
      setNumberError('Number must 10 digit.');
      return false;
    }
    setNumberError(null);
    return true;
  };

  const validateEmail = () => {
    if (!/^\w+@[a-z]+\.[a-z]+$/.test(email)) {
      setEmailError('Email must be in the format example@domain.com.');
      return false;
    }
    setEmailError(null);
    return true;
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validateName() && validateNumber() && validateEmail()) {
      alert('Form submitted successfully!');
    }
  };

   const handleChange = (event) => {
     setTermsAccepted(event.target.checked);
   };





  return(
    <div className="intro" id="intro">
     <div className="con">
        <div className="heading">
            <h1 className="mainheading">Ace your IELTS with<br/> Leverage Live</h1>
            <p className="subheading">70% of the students scored <span>7+ IELTS band</span></p>
            <div className="points-intro">
            <div className="point"><img  src="\assets\check.png" alt="check" className="check-bullets"/><p>Live Online classes</p></div>
            <div className="point"><img src="\assets\check.png" alt="check"className="check-bullets"/><p>Best Industry Experts</p></div>
            <div className="point"><img src="\assets\check.png" alt="check"className="check-bullets"/><p>Computerised Mock Tests & Performance Analysis</p></div>
            <div className="point"><img src="\assets\check.png" alt="check"className="check-bullets"/><p>One To One Speaking Assignment</p></div>
            <div className="point"><img src="\assets\check.png" alt="check" className="check-bullets"/><p>Personalised Feedback</p></div>
            <div className="point"><img src="\assets\check.png" alt="check" className="check-bullets"/><p>Flexible Timings</p></div>
            </div>
        </div>
        <div className="form">
          <form className="form-main" id="form" onSubmit={handleSubmit}>
          <input type="text" className="form-control" id="name" value={name} placeholder="Enter your full name"  onChange={(event) => setName(event.target.value)} required/>
          {nameError && <p style={{ color: 'red' }}>{nameError}</p>}
          <input type="email" className="form-control" id="email" value={email} placeholder="Email Adress" required onChange={(event) => setEmail(event.target.value)}/>
           {emailError && <p style={{ color: 'red' }}>{emailError}</p>}
          <input type="number" className="form-control" id="number" value={number} placeholder="Phone Number" required  onChange={(event) => setNumber(event.target.value)}/>
          {numberError && <p style={{ color: 'red' }}>{numberError}</p>}
          <input type="text" className="form-control" id="city" placeholder="City" required/>
           <div className="rinput"><input className="form-check-input mt-0 radio-input" type="checkbox" value="" checked={termsAccepted} onChange={handleChange} aria-label="Checkbox for following text input" required/><p className="terms-con">I have read all terms and conditions</p></div>
          <button type="submit" className="btn btn-primary my-button" disabled={!termsAccepted}>Book Your Free Trial</button>
          </form>
                <img className="cartoon-art" src="\assets\cartoonart.png" />
        </div>
      </div>
    </div>
  )
}
